

/**
 * This function is used for the patient stub for
 * pending bills
 */


export const patientStubForPendingBills = () => (
    {
      }
)